import {getCallMeBackDetailEvents} from './leads/detail/callMeBack.js'
import {getEmailDetailEvents} from './leads/detail/email.js'
import {getInstalmentDetailEvents} from './leads/detail/instalment.js'
import {getPhoneDetailEvents} from './leads/detail/phone.js'
import {getDetailPriAndProEvents} from './leads/detail/priAndPro.js'
import {getProfessionalDetailEvents} from './leads/detail/professional.js'
import {getRecommendedPhoneDetailEvents} from './leads/detail/recommendedPhone.js'
import {getReservationDetailEvents} from './leads/detail/reservation.js'
import {getWhatsappDetailEvents} from './leads/detail/whatsapp.js'
import {getFavoritesEvents} from './leads/favorites.js'
import {PROFESSIONAL_SELLER_TYPE} from './config.js'

const LEAD_GETTERS = [
  getEmailDetailEvents,
  getPhoneDetailEvents,
  getWhatsappDetailEvents,
  getCallMeBackDetailEvents,
  getDetailPriAndProEvents,
  getRecommendedPhoneDetailEvents,
  getReservationDetailEvents,
  getInstalmentDetailEvents,
  getFavoritesEvents,
  getProfessionalDetailEvents
]

export const getLeadEvents = ({event, properties}) => {
  const isProfessionalSeller = properties.seller_type === PROFESSIONAL_SELLER_TYPE
  return LEAD_GETTERS.flatMap(getter => getter({event, properties, isProfessionalSeller}))
}
